module.exports = __webpack_public_path__ + "img/ai.8b360ea5.jpg";